import { useDataModel } from '@thd-nucleus/data-sources';

/**
 * Data sources are product, collection and searchModel
 * Controlled data props.data always takes
 * priority and skips fetching entirely.
 */
export const useBreadcrumbData = ({
  itemId,
  collectionId,
  controlledData,
  controlledLoading,
  searchVariables,
  isControlledData
}) => {
  const productResponse = useDataModel('product', {
    skip: !itemId || isControlledData,
    variables: { itemId }
  });

  const collectionResponse = useDataModel('collection', {
    skip: !collectionId || isControlledData,
    variables: { collectionId }
  });

  const searchResponse = useDataModel('searchModel', {
    skip: isControlledData || collectionId || (!searchVariables?.keyword && !searchVariables?.navParam),
    variables: searchVariables
  });

  if (isControlledData) {
    return { data: controlledData, loading: controlledLoading ?? false };
  }
  if (itemId) {
    return { data: productResponse.data, loading: productResponse.loading };
  }
  if (collectionId) {
    return { data: collectionResponse.data, loading: collectionResponse.loading };
  }
  return {
    data: searchResponse.data, loading: searchResponse.loading
  };
};